import './DailyOverviewChart.css'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import StatusBadge from './StatusBadge';

Chart.register(ArcElement, Tooltip, Legend);

const ResultsDonutChart = ({ data, loading, error }) => {
    if (loading) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Execution overview</h2>
                <StatusBadge status="loading" label="Loading" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/loading-chart.png')} alt="Loading chart" />
            </div>
        </div>
    );

    if (error) return (
        <div className="empty-card ">
            <div className="metric-header">
                <h2>Execution overview</h2>
                <StatusBadge status="error" label="Error" className="flashing" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/error-chart.png')} alt="Loading chart" />
            </div>
        </div>
    );

    if (!data) return (
        <div className="empty-card ">
            <div className="metric-header">
                <h2>Execution overview</h2>
                <StatusBadge status="no-data" label="No data" className="flashing" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/no-data-chart.png')} alt="No data chart" />
            </div>
        </div>
    );

    const chartData = {
        labels: ['Passed', 'Failed', 'Skipped'],
        datasets: [
            {
                data: [
                    data.passed || 0,
                    data.failed || 0,
                    data.skipped || 0,
                ],
                backgroundColor: ['#4CAF50', '#F44336', '#9E9E9E'],
            },
        ],
    };
    const options = {
        plugins: {
            legend: {
                display: false,
            },
        },
    };

    return (
        <div className="empty-card ">
        <div className="metric-header">
            <h2>Execution overview</h2>
            <StatusBadge status="improved" label="Improved" />
        </div>
            <div className="chart-box">
                <Doughnut data={chartData} options={options} />
            </div>
        </div>
    );
};

export default ResultsDonutChart;